import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createBlock as _createBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-815afbb2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex flex-row flex-wrap" }
const _hoisted_2 = { class: "w-4 mr-5" }
const _hoisted_3 = { class: "mb-2 mt-2" }
const _hoisted_4 = {
  key: 0,
  src: "/img/fix-atyp.jpg",
  width: "250",
  alt: "Atypický fix"
}
const _hoisted_5 = {
  key: 1,
  src: "/img/fix-rectangle.jpg",
  width: "250",
  alt: "Atypický fix"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "atypical",
  class: "ml-2"
}, "Atypický (rôzne výšky)", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "formgroup-inline pl-2 w-full mb-1" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "text-xs font-light text-500 w-11rem" }, "Počet priedelov nie je počet skiel ")
], -1))
const _hoisted_8 = { class: "w-6 mr-2" }
const _hoisted_9 = { class: "mt-2 flex flex-row flex-wrap" }
const _hoisted_10 = {
  key: 0,
  class: "w-6"
}
const _hoisted_11 = { class: "" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("em", { class: "text-muted fs-6" }, [
    /*#__PURE__*/_createElementVNode("small", null, [
      /*#__PURE__*/_createTextVNode(" Pre celkové uloženie kliknite ešte na "),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode("ULOŽIŤ A PREPOČÍTAŤ ")
    ])
  ])
], -1))
const _hoisted_13 = { class: "w-6" }
const _hoisted_14 = { class: "pl-2" }
const _hoisted_15 = {
  class: "flex flex-wrap align-items-start",
  style: {"max-width":"200px"}
}
const _hoisted_16 = ["href"]
const _hoisted_17 = ["href"]
const _hoisted_18 = { key: 1 }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("em", null, "Pre tlač výrobných listov prejdite na zoznam objednávok a potom zvovu kliknite na danú objednávku.", -1))
const _hoisted_20 = [
  _hoisted_19
]
const _hoisted_21 = ["id"]
const _hoisted_22 = { class: "pt-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_row_input = _resolveComponent("row-input")!
  const _component_InputSwitch = _resolveComponent("InputSwitch")!
  const _component_InputGroupAddon = _resolveComponent("InputGroupAddon")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_PrimevueButton = _resolveComponent("PrimevueButton")!
  const _component_InputGroup = _resolveComponent("InputGroup")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_CardFixBinder = _resolveComponent("CardFixBinder")!
  const _component_CardFixGlass = _resolveComponent("CardFixGlass")!
  const _component_CardProfile = _resolveComponent("CardProfile")!
  const _component_ModalProfileList = _resolveComponent("ModalProfileList")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", null, [
          _createVNode(_component_row_input, {
            name: "fixName",
            id: "fixName",
            labelFront: "Názov fixu",
            labelBack: "[-]",
            defaultValue: this.store.order.fixes[this.$props.fixKey].name,
            validationAlert: !this.validationOK,
            type: "text",
            ref: "fixName",
            onNewWallValue: $options.changeInput
          }, null, 8, ["defaultValue", "validationAlert", "onNewWallValue"]),
          _createElementVNode("div", _hoisted_3, [
            (this.store.order.fixes[this.$props.fixKey].atypical)
              ? (_openBlock(), _createElementBlock("img", _hoisted_4))
              : (_openBlock(), _createElementBlock("img", _hoisted_5))
          ]),
          _createVNode(_component_row_input, {
            name: "width",
            id: "widthFix",
            required: "true",
            labelFront: "Šírka fixu",
            labelBack: "[mm]",
            defaultValue: this.store.order.fixes[this.$props.fixKey].width,
            type: "number",
            ref: "width",
            onNewWallValue: $options.changeInput
          }, null, 8, ["defaultValue", "onNewWallValue"]),
          _createVNode(_component_InputSwitch, {
            id: "atypical",
            modelValue: this.store.order.fixes[this.$props.fixKey].atypical,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((this.store.order.fixes[this.$props.fixKey].atypical) = $event)),
            class: "mt-2 offset-lock offset-lock-left",
            onInput: $options.changeInput
          }, null, 8, ["modelValue", "onInput"]),
          _hoisted_6,
          (this.store.order.fixes[this.$props.fixKey].atypical)
            ? (_openBlock(), _createBlock(_component_row_input, {
                key: 0,
                name: "heightA",
                id: "heightAfix",
                required: "true",
                labelFront: "Výška A",
                labelBack: "[mm]",
                defaultValue: this.store.order.fixes[this.$props.fixKey].heightA,
                type: "number",
                ref: "heightA",
                validationAlert: !this.validationOK,
                onNewWallValue: $options.changeInput
              }, null, 8, ["defaultValue", "validationAlert", "onNewWallValue"]))
            : (_openBlock(), _createBlock(_component_row_input, {
                key: 1,
                name: "heightA",
                id: "heightAfix",
                required: "true",
                labelFront: "Výška",
                labelBack: "[mm]",
                defaultValue: this.store.order.fixes[this.$props.fixKey].heightA,
                type: "number",
                ref: "heightA",
                validationAlert: !this.validationOK,
                onNewWallValue: $options.changeInput
              }, null, 8, ["defaultValue", "validationAlert", "onNewWallValue"])),
          (this.store.order.fixes[this.$props.fixKey].atypical)
            ? (_openBlock(), _createBlock(_component_row_input, {
                key: 2,
                name: "heightB",
                id: "heightBfix",
                required: "true",
                labelFront: "Výška B",
                labelBack: "[mm]",
                defaultValue: this.store.order.fixes[this.$props.fixKey].heightB,
                type: "number",
                ref: "heightB",
                validationAlert: !this.validationOK,
                onNewWallValue: $options.changeInput
              }, null, 8, ["defaultValue", "validationAlert", "onNewWallValue"]))
            : _createCommentVNode("", true),
          _createVNode(_component_row_input, {
            name: "glassType",
            id: "glassType",
            labelFront: "Typ skla",
            labelBack: "[-]",
            defaultValue: this.store.order.fixes[this.$props.fixKey].glassType,
            validationAlert: !this.validationOK,
            type: "text",
            ref: "glassType",
            onNewWallValue: $options.changeInput
          }, null, 8, ["defaultValue", "validationAlert", "onNewWallValue"]),
          _createVNode(_component_InputGroup, { class: "w-full mt-1" }, {
            default: _withCtx(() => [
              _createVNode(_component_InputGroupAddon, { class: "w-7 font-normal text-base text-700 justify-content-start" }, {
                default: _withCtx(() => [
                  _createTextVNode("Rámový profil ")
                ]),
                _: 1
              }),
              _createVNode(_component_Dropdown, {
                onChange: $options.changeProfile,
                modelValue: this.store.order.fixes[this.$props.fixKey].profile.id,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((this.store.order.fixes[this.$props.fixKey].profile.id) = $event)),
                options: this.store.ramed_profile_type,
                optionLabel: "name",
                optionValue: "code",
                placeholder: this.store.order.fixes[this.$props.fixKey].profile.name,
                class: "w-2",
                inputStyle: "padding-left: 0.3rem; padding-top: 0.1rem"
              }, null, 8, ["onChange", "modelValue", "options", "placeholder"]),
              _createVNode(_component_PrimevueButton, {
                onClick: _cache[2] || (_cache[2] = ($event: any) => ($options.visibleProfiles(false))),
                class: "help-button w-2",
                label: "Nápoveda",
                severity: "warning"
              })
            ]),
            _: 1
          }),
          _createVNode(_component_InputGroup, { class: "w-full mt-1" }, {
            default: _withCtx(() => [
              _createVNode(_component_InputGroupAddon, { class: "w-7 font-normal text-base text-700 justify-content-start" }, {
                default: _withCtx(() => [
                  _createTextVNode("Počet priedelov ")
                ]),
                _: 1
              }),
              _createVNode(_component_Dropdown, {
                onChange: $options.changeSelect,
                modelValue: this.store.order.fixes[this.$props.fixKey].binderCount,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((this.store.order.fixes[this.$props.fixKey].binderCount) = $event)),
                options: this.store.binder_options,
                optionLabel: "name",
                optionValue: "code",
                placeholder: this.store.order.fixes[this.$props.fixKey].binderCount,
                class: "w-2",
                inputStyle: "padding-left: 0.3rem; padding-top: 0.1rem"
              }, null, 8, ["onChange", "modelValue", "options", "placeholder"]),
              _createVNode(_component_InputGroupAddon, { class: "w-2 font-normal text-sm" }, {
                default: _withCtx(() => [
                  _createTextVNode("[ks]")
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _hoisted_7,
          (this.store.order.fixes[this.$props.fixKey].binderCount > 0)
            ? (_openBlock(), _createBlock(_component_InputGroup, {
                key: 3,
                class: "w-full mt-1"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_InputGroupAddon, { class: "w-7 font-normal text-base text-700 justify-content-start" }, {
                    default: _withCtx(() => [
                      _createTextVNode("Priečnikový profil ")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Dropdown, {
                    onChange: $options.changeBinderProfile,
                    modelValue: this.store.order.fixes[this.$props.fixKey].binderProfile.id,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((this.store.order.fixes[this.$props.fixKey].binderProfile.id) = $event)),
                    options: this.store.binder_profile_type,
                    optionLabel: "name",
                    optionValue: "code",
                    placeholder: this.store.order.fixes[this.$props.fixKey].binderProfile.name,
                    class: "w-2",
                    inputStyle: "padding-left: 0.3rem; padding-top: 0.1rem"
                  }, null, 8, ["onChange", "modelValue", "options", "placeholder"]),
                  _createVNode(_component_PrimevueButton, {
                    onClick: _cache[5] || (_cache[5] = ($event: any) => ($options.visibleProfiles(true))),
                    class: "help-button w-2",
                    label: "Nápoveda",
                    severity: "warning"
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_InputGroup, { class: "w-full mt-1" }, {
            default: _withCtx(() => [
              _createVNode(_component_InputGroupAddon, { class: "w-2 h-full font-normal text-base text-700 justify-content-start" }, {
                default: _withCtx(() => [
                  _createTextVNode("Pozn. ")
                ]),
                _: 1
              }),
              _createVNode(_component_InputText, {
                class: "w-full justify-content-start",
                name: "fixComment",
                id: "fixComment",
                placeholder: "Zadaj poznámku k fixu",
                modelValue: this.store.order.fixes[this.$props.fixKey].desc,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((this.store.order.fixes[this.$props.fixKey].desc) = $event)),
                autocomplete: "fixComment-new"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_component_InputGroup, { class: "" }, {
          default: _withCtx(() => [
            _createVNode(_component_InputGroupAddon, { class: "w-full uppercase font-medium text-sm text-800 bg-red-300" }, {
              default: _withCtx(() => [
                _createTextVNode("Výstupné údaje ")
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_9, [
          (this.store.order.fixes[this.$props.fixKey].binderCount > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _createVNode(_component_InputGroup, { class: "mt-1" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_InputGroupAddon, { class: "w-full uppercase font-medium text-sm text-800 bg-red-100" }, {
                      default: _withCtx(() => [
                        _createTextVNode("Zoznam priečnikov - profil " + _toDisplayString(this.store.order.fixes[this.$props.fixKey].binderProfile.name) + " (" + _toDisplayString(this.store.order.fixes[this.$props.fixKey].binderProfile.width) + "mm) ", 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.store.order.fixes[this.$props.fixKey].fixBinders, (fixB, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: index,
                    class: "align-items-center justify-content-center w-full surface-card shadow-2 border-round-lg mt-1"
                  }, [
                    _createVNode(_component_CardFixBinder, {
                      fixBinderKey: index,
                      fixKey: this.$props.fixKey,
                      onChangeFixBinder: $options.changeFixBinder
                    }, null, 8, ["fixBinderKey", "fixKey", "onChangeFixBinder"])
                  ]))
                }), 128)),
                _createElementVNode("a", _hoisted_11, [
                  _createVNode(_component_PrimevueButton, {
                    class: "mt-5 bg-pink-300",
                    label: "Prepočítať rozostupy",
                    severity: "info",
                    icon: "pi pi-refresh",
                    raised: "",
                    onClick: _cache[7] || (_cache[7] = ($event: any) => ($options.calculateBinderOffsets()))
                  })
                ]),
                _hoisted_12
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_13, [
            _createVNode(_component_InputGroup, { class: "mt-1" }, {
              default: _withCtx(() => [
                _createVNode(_component_InputGroupAddon, { class: "w-full uppercase font-medium text-sm text-800 bg-red-100" }, {
                  default: _withCtx(() => [
                    _createTextVNode("Zoznam skiel ")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.store.order.fixes[this.$props.fixKey].fixGlasses, (fixG, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                class: "align-items-center justify-content-center w-full surface-card shadow-2 border-round-lg mt-1"
              }, [
                _createVNode(_component_CardFixGlass, {
                  fixGlassKey: index,
                  fixKey: this.$props.fixKey,
                  onChangeFixGlass: $options.changeFixGlass
                }, null, 8, ["fixGlassKey", "fixKey", "onChangeFixGlass"])
              ]))
            }), 128))
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("div", _hoisted_15, [
          (this.store.order.fixes[this.$props.fixKey].id > 0)
            ? (_openBlock(), _createElementBlock("a", {
                key: 0,
                href: this.previewUrl,
                target: "_blank"
              }, [
                _createVNode(_component_PrimevueButton, {
                  class: "mt-2 align-items-center justify-content-center",
                  label: "Zobraziť výrobný list",
                  severity: "info",
                  icon: "pi pi-eye",
                  text: "",
                  raised: "",
                  disabled: this.store.order.fixes[this.$props.fixKey].id === 0
                }, null, 8, ["disabled"])
              ], 8, _hoisted_16))
            : _createCommentVNode("", true),
          _createElementVNode("a", {
            href: this.printUrl,
            target: "_blank"
          }, [
            _createVNode(_component_PrimevueButton, {
              class: "mt-5 align-items-center justify-content-center",
              label: "Tlačiť výrobný list",
              severity: "info",
              icon: "pi pi-print",
              text: "",
              raised: "",
              disabled: this.store.order.fixes[this.$props.fixKey].id === 0
            }, null, 8, ["disabled"])
          ], 8, _hoisted_17),
          (this.store.order.fixes[this.$props.fixKey].id === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_18, _hoisted_20))
            : _createCommentVNode("", true),
          _createVNode(_component_PrimevueButton, {
            class: "mt-5 align-items-center justify-content-center",
            label: "Vymaž fix",
            severity: "danger",
            icon: "pi pi-trash",
            text: "",
            raised: "",
            onClick: _cache[8] || (_cache[8] = ($event: any) => ($options.deleteFix(this.$props.fixKey)))
          })
        ]),
        _createElementVNode("iframe", {
          id: `iFramePrintPdf-`+ this.store.order.fixes[this.$props.fixKey].id,
          style: {"display":"none"}
        }, null, 8, _hoisted_21)
      ])
    ]),
    _createVNode(_component_ModalProfileList, {
      visible: $data.visibleProfileList,
      "onUpdate:visible": _cache[10] || (_cache[10] = ($event: any) => (($data.visibleProfileList) = $event)),
      modal: "",
      header: this.isBinderProfile ? 'Zoznam typov priečnikových profilov' :'Zoznam typov rámových profilov' ,
      style: { width: '40rem' },
      closeOnEscape: "true",
      breakpoints: { '1199px': '75vw', '575px': '90vw' }
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_PrimevueButton, {
          text: "",
          raised: "",
          label: "Zavrieť",
          severity: "secondary",
          onClick: _cache[9] || (_cache[9] = ($event: any) => ($data.visibleProfileList = false))
        })
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_22, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.profileList, (profile, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              class: "surface-card shadow-2 border-round-lg mt-1"
            }, [
              _createVNode(_component_CardProfile, { profile: profile }, null, 8, ["profile"])
            ]))
          }), 128))
        ])
      ]),
      _: 1
    }, 8, ["visible", "header"])
  ], 64))
}